import { Transaction } from '@tassat/fred-definitions';

interface TransactionsState {
    transactions: {
        [id: string]: Transaction;
    };
    pendingTransactions: {
        [id: string]: Transaction;
    };
    haltRealtimeTransactions: boolean;
}

const initialState: TransactionsState = {
    transactions: {},
    pendingTransactions: {},
    haltRealtimeTransactions: false
};

export default function transactionsReducer(state: TransactionsState = initialState, action) {
    const mappedTxs = {};
    switch (action.type) {
        case 'SET_TRANSACTIONS':
            action.payload.forEach((tx) => {
                const reducerId = `${tx.RequestId}-${tx.type}`;
                mappedTxs[reducerId] = tx;
            });

            return {
                ...state,
                transactions: mappedTxs
            };
        case 'SET_PENDING_TRANSACTIONS':
            action.payload.forEach((tx) => {
                const reducerId = `${tx.RequestId}-${tx.type}`;
                mappedTxs[reducerId] = tx;
            });

            return {
                ...state,
                pendingTransactions: mappedTxs
            };
        case 'Transaction': {
            const reducerId = `${action.payload.RequestId}-${action.payload.type}`;
            if (state.haltRealtimeTransactions && !state.transactions[reducerId]) {
                return state;
            }

            if (!(action.payload as Transaction).IsCompleted) {
                return {
                    ...state,
                    pendingTransactions: {
                        ...state.pendingTransactions,
                        [reducerId]: {
                            ...state.pendingTransactions[reducerId],
                            ...action.payload
                        }
                    },
                    transactions: {
                        ...state.transactions,
                        [reducerId]: {
                            ...state.transactions[reducerId],
                            ...action.payload
                        }
                    }
                };
            } else if ((action.payload as Transaction).IsCompleted) {
                const filteredPendingTransactions = { ...state.pendingTransactions };
                if (state.pendingTransactions[reducerId]) {
                    delete filteredPendingTransactions[reducerId];
                }

                return {
                    ...state,
                    pendingTransactions: filteredPendingTransactions,
                    transactions: {
                        ...state.transactions,
                        [reducerId]: {
                            ...state.transactions[reducerId],
                            ...action.payload
                        }
                    }
                };
            }

            return {
                ...state,
                pendingTransactions: { ...state.pendingTransactions },
                transactions: {
                    ...state.transactions,
                    [reducerId]: {
                        ...state.transactions[reducerId],
                        ...action.payload
                    }
                }
            };
        }
        case 'HALT_REALTIME_TRANSACTIONS':
            return {
                ...state,
                haltRealtimeTransactions: true
            };
        case 'RESUME_REALTIME_TRANSACTIONS':
            return {
                ...state,
                haltRealtimeTransactions: false
            };
        default:
            return state;
    }
}